// import React, { useState } from 'react';
// import { motion } from "framer-motion";
// import { MdEmail, MdLocationOn, MdPhoneInTalk } from "react-icons/md";
// import { IoCallSharp } from "react-icons/io5";
// import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";
// import { FiSend } from "react-icons/fi";
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const Contact = () => {
//     const handleSubmit = (e) => {
//         e.preventDefault();
//         toast.success("Message Sent Successfully! 🚀");
//     };

//     return (
//         <div style={s.pageWrapper}>
//             <style>{globalCSS}</style>
//             <ToastContainer theme="dark" />

//             <div style={{ ...s.orb, ...s.orbTopRight }}></div>
//             <div style={{ ...s.orb, ...s.orbBottomLeft }}></div>

//             <div style={s.container}>
//                 <div style={s.headerSection}>
//                     <h1 style={s.mainTitle}>Contact Us</h1>
//                     <p style={s.subTitle}>Any question or remarks? Just write us a message!</p>
//                 </div>

//                 <motion.div
//                     initial={{ opacity: 0, y: 30 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.8 }}
//                     style={s.glassCard}
//                 >
//                     {/* LEFT PANEL: CONTENT SECTION */}
//                     <div style={s.infoSide}>
//                         <div>
//                             <h2 style={s.cardTitle}>Contact Information</h2>
//                             <p style={{ color: '#555', fontSize: '14px', marginTop: '-30px', marginBottom: '40px' }}>Say something to start a live chat!</p>
//                         </div>

//                         <div style={s.contactInfoList}>
//                             <div style={s.infoItem}>
//                                 <MdEmail size={24} color="#fff" />
//                                 <div>
//                                     <b style={s.label}>Email</b>
//                                     <p style={s.val}>info@galaxyerpsoftware.com</p>
//                                 </div>
//                             </div>
//                             <div style={s.infoItem}>
//                                 <MdPhoneInTalk size={24} color="#fff" />
//                                 <div>
//                                     <b style={s.label}>Office Number</b>
//                                     <p style={s.val}>+91-9638177750</p>
//                                     <p style={s.val}>+91-8128061833</p>
//                                 </div>
//                             </div>
//                             <div style={s.infoItem}>
//                                 <MdLocationOn size={24} color="#fff" />
//                                 <div>
//                                     <b style={s.label}>Office Address</b>
//                                     <p style={s.val}>410, The Boulevard, Pratham Circle Opp Pal RTO, Pal, Green City Rd, Adajan, Surat, Gujarat 395009.</p>
//                                 </div>
//                             </div>
//                             <div style={s.infoItem}>
//                                 <IoCallSharp size={24} color="#fff" />
//                                 <div>
//                                     <b style={s.label}>Business Enquiry</b>
//                                     <p style={s.val}>+91-9924577750</p>
//                                     <p style={s.val}>sales@galaxyerpsoftware.com</p>
//                                 </div>
//                             </div>
//                         </div>

//                         <div style={s.socialContainer}>
//                             {/* Facebook લિંક - Galaxy ERP */}
//                             <a
//                                 href="https://www.facebook.com/people/Galaxy-ERP/61557637277831/"
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="soc-btn fb"
//                                 title="Follow us on Facebook"
//                             >
//                                 <FaFacebookF />
//                             </a>

//                             {/* Instagram લિંક - Galaxy ERP */}
//                             <a
//                                 href="https://www.instagram.com/galaxyerpsoftwarepvtltd/"
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="soc-btn ig"
//                                 title="Follow us on Instagram"
//                             >
//                                 <FaInstagram />
//                             </a>

//                             {/* LinkedIn લિંક - Galaxy ERP */}
//                             <a
//                                 href="https://www.linkedin.com/company/galaxy-erp-software-private-limited/"
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="soc-btn li"
//                                 title="Connect on LinkedIn"
//                             >
//                                 <FaLinkedinIn />
//                             </a>
//                         </div>
//                     </div>

//                     {/* RIGHT PANEL: FORM SECTION - Name, Email, Message Only */}
//                     <div style={s.formSide}>
//                         <form onSubmit={handleSubmit} style={s.formLayout}>
//                             <div style={s.inputGroup}>
//                                 <label style={s.fieldLabel}>Name</label>
//                                 <input type="text" style={s.lineInput} placeholder="Enter your full name" />
//                             </div>

//                             <div style={s.inputGroup}>
//                                 <label style={s.fieldLabel}>Email Address</label>
//                                 <input type="email" style={s.lineInput} placeholder="Enter your email address" />
//                             </div>

//                             <div style={{ gridColumn: 'span 1', marginTop: '15px' }}>
//                                 <label style={s.fieldLabel}>Message</label>
//                                 <textarea style={s.messageArea} placeholder="Enter your message here..."></textarea>
//                             </div>

//                             <div style={{ gridColumn: 'span 1', textAlign: 'right', position: 'relative', marginTop: '60px' }}>
//                                 <button type="submit" className="submit-plane-btn" style={s.submitButton}>
//                                     Send Message
//                                 </button>

//                                 {/* Plane & Dashed Line Design */}
//                                 <div style={s.planeWrap}>
//                                     <svg width="120" height="60" viewBox="0 0 120 60" style={s.dashSvg}>
//                                         <path d="M10,50 Q60,10 110,50" fill="none" stroke="#444" strokeWidth="2" strokeDasharray="6,6" />
//                                     </svg>
//                                     <div style={s.planeCircle}>
//                                         <FiSend style={s.planeIcon} />
//                                     </div>
//                                 </div>
//                                 <div style={s.dotsPattern}></div>
//                             </div>
//                         </form>
//                     </div>
//                 </motion.div>

//                 {/* Map Section */}
//                 <div style={s.mapContainer}>
//                     <iframe
//                         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.123456789!2d72.7812345!3d21.1812345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjHCsDEwJzUyLjQiTiA3MsKwNDYnNTIuNCJF!5e0!3m2!1sen!2sin!4v1234567890"
//                         width="100%" height="400"
//                         style={{ border: 0, borderRadius: '25px', filter: 'invert(90%) hue-rotate(180deg)' }}
//                         allowFullScreen="" loading="lazy"
//                     ></iframe>
//                 </div>
//             </div>
//         </div>
//     );
// };

// const s = {
//     pageWrapper: { backgroundColor: '#000', minHeight: '100vh', padding: '100px 20px', position: 'relative', overflowX: 'hidden', color: '#fff', fontFamily: "'Poppins', sans-serif" },
//     orb: { position: 'absolute', width: '400px', height: '400px', borderRadius: '50%', filter: 'blur(80px)', opacity: '0.25', zIndex: 1 },
//     orbTopRight: { background: '#00d2ff', top: '-5%', right: '-5%' },
//     orbBottomLeft: { background: '#8E2DE2', bottom: '5%', left: '-5%' },

//     container: { maxWidth: '1150px', margin: '0 auto', position: 'relative', zIndex: 10 },
//     headerSection: { textAlign: 'center', marginBottom: '60px' },
//     mainTitle: { fontSize: '50px', fontWeight: '800', margin: 0, letterSpacing: '-1.5px' },
//     subTitle: { color: '#666', fontSize: '16px', marginTop: '20px' },

//     glassCard: { display: 'flex', flexWrap: 'wrap', background: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(30px)', borderRadius: '30px', border: '1px solid rgba(255, 255, 255, 0.1)', overflow: 'hidden' },

//     infoSide: { flex: '1', minWidth: '350px', padding: '50px', background: '#000', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderRight: '1px solid #111' },
//     cardTitle: { fontSize: '28px', fontWeight: '700', marginBottom: '40px' },
//     contactInfoList: { display: 'flex', flexDirection: 'column', gap: '30px' },
//     infoItem: { display: 'flex', alignItems: 'flex-start', gap: '20px' },
//     label: { display: 'block', fontSize: '14px', color: '#fff', marginBottom: '2px' },
//     val: { color: '#888', fontSize: '14px', margin: 0, lineHeight: '1.5' },
//     socialContainer: { display: 'flex', gap: '15px', marginTop: '50px' },

//     formSide: { flex: '1.5', minWidth: '350px', padding: '50px', position: 'relative' },
//     formLayout: { display: 'grid', gridTemplateColumns: '1fr', gap: '40px' },
//     inputGroup: { display: 'flex', flexDirection: 'column', gap: '8px' },
//     fieldLabel: { fontSize: '12px', fontWeight: '600', color: '#555', textTransform: 'uppercase', letterSpacing: '1px' },
//     lineInput: { background: 'transparent', border: 'none', borderBottom: '1px solid #333', padding: '10px 0', color: '#fff', fontSize: '16px', outline: 'none' },
//     messageArea: { background: 'transparent', border: 'none', borderBottom: '1px solid #333', padding: '10px 0', color: '#fff', fontSize: '16px', outline: 'none', width: '100%', height: '80px', resize: 'none' },

//     submitButton: { padding: '14px 45px', borderRadius: '8px', border: '1px solid #333', background: '#000', color: '#fff', fontSize: '15px', fontWeight: '700', cursor: 'pointer', transition: '0.3s', zIndex: 10, position: 'relative' },

//     planeWrap: { position: 'absolute', right: '-10px', bottom: '-20px', width: '120px', height: '80px' },
//     dashSvg: { position: 'absolute', bottom: '10px', right: '10px', opacity: 0.4 },
//     planeCircle: { position: 'absolute', bottom: '15px', right: '0', width: '50px', height: '50px', borderRadius: '50%', background: 'rgba(0,210,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', transform: 'rotate(-40deg)' },
//     planeIcon: { fontSize: '24px', color: '#00d2ff' },
//     dotsPattern: { position: 'absolute', bottom: '-20px', right: '20px', width: '100px', height: '40px', background: 'radial-gradient(#222 1.5px, transparent 1.5px)', backgroundSize: '12px 12px', opacity: '0.6' },

//     mapContainer: { marginTop: '50px', borderRadius: '30px', overflow: 'hidden', border: '1px solid #111' }
// };

// const globalCSS = `
//     .soc-btn { width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; text-decoration: none; transition: 0.3s; font-size: 18px; }
//     .fb { background: #1877F2; }
//     .ig { background: linear-gradient(45deg, #f09433, #dc2743, #bc1888); }
//     .li { background: #0077B5; }
//     .tw { background: #1DA1F2; }
//     .soc-btn:hover { transform: translateY(-5px); opacity: 0.8; }

//     input:focus, textarea:focus { border-bottom-color: #00d2ff !important; }
//     .submit-plane-btn:hover { background: #fff !important; color: #000 !important; }

//     @media (max-width: 900px) {
//         .planeWrap, .dotsPattern { display: none !important; }
//     }
// `;

// export default Contact;

import React, { useState } from 'react';
import { motion } from "framer-motion";
import { MdEmail, MdLocationOn, MdPhoneInTalk } from "react-icons/md";
import { IoCallSharp } from "react-icons/io5";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FiSend } from "react-icons/fi";
import emailjs from 'emailjs-com';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // EmailJS integration with your new Service ID
        emailjs.send(
            'service_jqvaw1k',
            'template_iqkg6yd',
            formData,
            'cEHIFlFveDcaflpnE'
        )
            .then((result) => {
                toast.success("Message Sent Successfully! 🚀");
                setFormData({ name: '', email: '', message: '' });
            }, (error) => {
                console.error("EmailJS Error:", error);
                toast.error("Failed to send message. Please try again.");
            });
    };

    return (
        <div style={s.pageWrapper}>
            <style>{globalCSS}</style>
            <ToastContainer theme="dark" />

            <div style={{ ...s.orb, ...s.orbTopRight }}></div>
            <div style={{ ...s.orb, ...s.orbBottomLeft }}></div>

            <div style={s.container}>
                <div style={s.headerSection}>
                    <h1 style={s.mainTitle}>Contact Us</h1>
                    <p style={s.subTitle}>Any question or remarks? Just write us a message!</p>
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    style={s.glassCard}
                >
                    {/* LEFT PANEL: CONTENT SECTION */}
                    <div style={s.infoSide}>
                        <div>
                            <h2 style={s.cardTitle}>Contact Information</h2>
                            <p style={{ color: '#555', fontSize: '14px', marginTop: '-30px', marginBottom: '40px' }}>Say something to start a live chat!</p>
                        </div>

                        <div style={s.contactInfoList}>
                            <div style={s.infoItem}>
                                <MdEmail size={24} color="#fff" />
                                <div>
                                    <b style={s.label}>Email</b>
                                    <p style={s.val}>info@galaxyerpsoftware.com</p>
                                </div>
                            </div>
                            <div style={s.infoItem}>
                                <MdPhoneInTalk size={24} color="#fff" />
                                <div>
                                    <b style={s.label}>Office Number</b>
                                    <p style={s.val}>+91-9638177750</p>
                                    <p style={s.val}>+91-8128061833</p>
                                </div>
                            </div>
                            <div style={s.infoItem}>
                                <MdLocationOn size={24} color="#fff" />
                                <div>
                                    <b style={s.label}>Office Address</b>
                                    <p style={s.val}>410, The Boulevard, Pratham Circle Opp Pal RTO, Pal, Green City Rd, Adajan, Surat, Gujarat 395009.</p>
                                </div>
                            </div>
                            <div style={s.infoItem}>
                                <IoCallSharp size={24} color="#fff" />
                                <div>
                                    <b style={s.label}>Business Enquiry</b>
                                    <p style={s.val}>+91-9924577750</p>
                                    <p style={s.val}>sales@galaxyerpsoftware.com</p>
                                </div>
                            </div>
                        </div>

                        <div style={s.socialContainer}>
                            <a href="https://www.facebook.com/people/Galaxy-ERP/61557637277831/" target="_blank" rel="noopener noreferrer" className="soc-btn fb" title="Facebook"><FaFacebookF /></a>
                            <a href="https://www.instagram.com/galaxyerpsoftwarepvtltd/" target="_blank" rel="noopener noreferrer" className="soc-btn ig" title="Instagram"><FaInstagram /></a>
                            <a href="https://www.linkedin.com/company/galaxy-erp-software-private-limited/" target="_blank" rel="noopener noreferrer" className="soc-btn li" title="LinkedIn"><FaLinkedinIn /></a>
                        </div>
                    </div>

                    {/* RIGHT PANEL: FORM SECTION */}
                    <div style={s.formSide}>
                        <form onSubmit={handleSubmit} style={s.formLayout}>
                            <div style={s.inputGroup}>
                                <label style={s.fieldLabel}>Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    style={s.lineInput}
                                    placeholder="Enter your full name"
                                    required
                                />
                            </div>

                            <div style={s.inputGroup}>
                                <label style={s.fieldLabel}>Email Address</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    style={s.lineInput}
                                    placeholder="Enter your email address"
                                    required
                                />
                            </div>

                            <div style={{ gridColumn: 'span 1', marginTop: '15px' }}>
                                <label style={s.fieldLabel}>Message</label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    style={s.messageArea}
                                    placeholder="Enter your message here..."
                                    required
                                ></textarea>
                            </div>

                            <div style={{ gridColumn: 'span 1', textAlign: 'right', position: 'relative', marginTop: '60px' }}>
                                <button type="submit" className="submit-plane-btn" style={s.submitButton}>
                                    Send Message
                                </button>

                                <div style={s.planeWrap}>
                                    <svg width="120" height="80" viewBox="0 0 120 80" style={s.dashSvg}>
                                        <path
                                            d="M0,60 C30,60 80,50 110,10"
                                            fill="none"
                                            stroke="#00d2ff"
                                            strokeWidth="2"
                                            strokeDasharray="6,6"
                                            opacity="0.5"
                                        />
                                    </svg>
                                    <div style={s.planeCircle}>
                                        <FiSend style={s.planeIcon} />
                                    </div>
                                </div>
                                <div style={s.dotsPattern}></div>
                            </div>
                        </form>
                    </div>
                </motion.div>

                {/* Map Section - FIXED URL */}
                {/* <div style={s.mapContainer}>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.123456789!2d72.784!3d21.185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04d9095697d83%3A0xcf39b152d589f55e!2sGalaxy%20ERP%20Software%20Private%20Limited!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin"
                        width="100%" height="400"
                        style={{ border: 0, borderRadius: '25px', filter: 'invert(90%) hue-rotate(180deg)' }}
                        allowFullScreen="" loading="lazy"
                        title="Galaxy ERP Office Location"
                    ></iframe>
                </div> */}
                {/* Map Section - Dark Theme with White Info Box */}
                <div style={s.mapContainer}>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.123!2d72.78!3d21.18!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04df6b3f81ead%3A0x3265271ba545962f!2sGalaxyERP%20Software%20Private%20Limited!5e0!3m2!1sen!2sin!4v1705840000000!5m2!1sen!2sin"
                        width="100%"
                        height="450"
                        style={{
                            border: 0,
                            borderRadius: '25px',
                            filter: ' invert(90%) hue-rotate(180deg)'
                        }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Galaxy ERP Office Location"
                    ></iframe>

                    <style>{`
        .map-container iframe {
            filter: none !important;
        }
    `}</style>
                </div>
            </div>
        </div>
    );
};

const s = {
    pageWrapper: { backgroundColor: '#000', minHeight: '100vh', padding: '100px 20px', position: 'relative', overflowX: 'hidden', color: '#fff', fontFamily: "'Poppins', sans-serif" },
    orb: { position: 'absolute', width: '400px', height: '400px', borderRadius: '50%', filter: 'blur(80px)', opacity: '0.25', zIndex: 1 },
    orbTopRight: { background: '#00d2ff', top: '-5%', right: '-5%' },
    orbBottomLeft: { background: '#8E2DE2', bottom: '5%', left: '-5%' },
    container: { maxWidth: '1150px', margin: '0 auto', position: 'relative', zIndex: 10 },
    headerSection: { textAlign: 'center', marginBottom: '60px' },
    mainTitle: { fontSize: '50px', fontWeight: '800', margin: 0, letterSpacing: '-1.5px' },
    subTitle: { color: '#666', fontSize: '16px', marginTop: '20px' },
    glassCard: { display: 'flex', flexWrap: 'wrap', background: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(30px)', borderRadius: '30px', border: '1px solid rgba(255, 255, 255, 0.1)', overflow: 'hidden' },
    infoSide: { flex: '1', minWidth: '350px', padding: '50px', background: '#000', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderRight: '1px solid #111' },
    cardTitle: { fontSize: '28px', fontWeight: '700', marginBottom: '40px' },
    contactInfoList: { display: 'flex', flexDirection: 'column', gap: '30px' },
    infoItem: { display: 'flex', alignItems: 'flex-start', gap: '20px' },
    label: { display: 'block', fontSize: '14px', color: '#fff', marginBottom: '2px' },
    val: { color: '#888', fontSize: '14px', margin: 0, lineHeight: '1.5' },
    socialContainer: { display: 'flex', gap: '15px', marginTop: '50px' },
    formSide: { flex: '1.5', minWidth: '350px', padding: '50px', position: 'relative' },
    formLayout: { display: 'grid', gridTemplateColumns: '1fr', gap: '40px' },
    inputGroup: { display: 'flex', flexDirection: 'column', gap: '8px' },
    fieldLabel: { fontSize: '12px', fontWeight: '600', color: '#555', textTransform: 'uppercase', letterSpacing: '1px' },
    lineInput: { background: 'transparent', border: 'none', borderBottom: '1px solid #333', padding: '10px 0', color: '#fff', fontSize: '16px', outline: 'none' },
    messageArea: { background: 'transparent', border: 'none', borderBottom: '1px solid #333', padding: '10px 0', color: '#fff', fontSize: '16px', outline: 'none', width: '100%', height: '80px', resize: 'none' },
    submitButton: { padding: '14px 45px', borderRadius: '8px', border: '1px solid #333', background: '#000', color: '#fff', fontSize: '15px', fontWeight: '700', cursor: 'pointer', transition: '0.3s', zIndex: 5, position: 'relative' },
    planeWrap: {
        position: 'absolute',
        right: '-40px', 
        bottom: '-30px',
        width: '150px',
        height: '100px',
        pointerEvents: 'none',
        zIndex: 10 
    },
    planeCircle: {
        position: 'absolute',
        top: '10px', 
        right: '10px',
        width: '45px',
        height: '45px',
        borderRadius: '50%',
        background: 'rgba(0,210,255,0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'rotate(-10deg)', 
        boxShadow: '0 0 15px rgba(0,210,255,0.2)'
    },
    dashSvg: {
        position: 'absolute',
        top: '30px',
        right: '35px',
        opacity: 0.6,
        overflow: 'visible'
    },
    planeIcon: { fontSize: '24px', color: '#00d2ff' },
    dotsPattern: { position: 'absolute', bottom: '-20px', right: '20px', width: '100px', height: '40px', background: 'radial-gradient(#222 1.5px, transparent 1.5px)', backgroundSize: '12px 12px', opacity: '0.6' },
    mapContainer: { marginTop: '50px', borderRadius: '30px', overflow: 'hidden', border: '1px solid #111' }
};

const globalCSS = `
    .soc-btn { width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; text-decoration: none; transition: 0.3s; font-size: 18px; }
    .fb { background: #1877F2; }
    .ig { background: linear-gradient(45deg, #f09433, #dc2743, #bc1888); }
    .li { background: #0077B5; }
    .soc-btn:hover { transform: translateY(-5px); opacity: 0.8; }
    input:focus, textarea:focus { border-bottom-color: #00d2ff !important; }
    .submit-plane-btn:hover { background: #fff !important; color: #000 !important; }
    @media (max-width: 900px) {
        .planeWrap, .dotsPattern { display: none !important; }
    }
`;

export default Contact;